import React from "react";
import { ArrowRight, TrendingDown, Zap } from "lucide-react";
import { Button } from "./ui/button";

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-slate-50 to-white"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 rounded-full mb-8 fade-in">
            <div className="w-2 h-2 bg-[#1e3a8a] rounded-full animate-pulse"></div>
            <span className="text-sm font-medium text-[#1e3a8a]">
              Procurement Expertise for SMEs
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight fade-in-up delay-100">
            Helping small and medium-sized businesses{" "}
            <span className="text-[#1e3a8a]">reduce cost</span>,{" "}
            <span className="text-[#1e3a8a]">improve efficiency</span>, and{" "}
            <span className="text-[#1e3a8a]">modernise procurement</span>
          </h1>

          {/* Subheading */}
          <p className="text-xl sm:text-2xl text-gray-600 mb-12 leading-relaxed fade-in-up delay-200">
            Simplify and inexpensively transform your procurement operations
            with strategic expertise
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center fade-in-up delay-300">
            <Button
              onClick={scrollToContact}
              className="bg-[#1e3a8a] hover:bg-[#1e40af] text-white px-8 py-6 text-lg group"
              size="lg"
            >
              Contact Us
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              onClick={() => {
                const element = document.getElementById("services");
                if (element) element.scrollIntoView({ behavior: "smooth" });
              }}
              variant="outline"
              className="border-2 border-[#1e3a8a] text-[#1e3a8a] hover:bg-[#1e3a8a] hover:text-white px-8 py-6 text-lg"
              size="lg"
            >
              Explore Services
            </Button>
          </div>

          {/* Value Props */}
          <div className="mt-20 grid grid-cols-1 sm:grid-cols-3 gap-8 fade-in-up delay-400">
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4">
                <TrendingDown className="w-8 h-8 text-[#1e3a8a]" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Reduce Costs
              </h3>
              <p className="text-gray-600 text-center">
                Strategic sourcing that delivers measurable savings
              </p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4">
                <Zap className="w-8 h-8 text-[#1e3a8a]" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Improve Efficiency
              </h3>
              <p className="text-gray-600 text-center">
                Streamlined processes and optimized workflows
              </p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4">
                <svg
                  className="w-8 h-8 text-[#1e3a8a]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Modernise Systems
              </h3>
              <p className="text-gray-600 text-center">
                Digital transformation for competitive advantage
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};